import React, { useState } from "react";
import { databaseKey } from "../components/common/database_key";
import { fetchData, pushData } from "../components/firebase/firebase_methods";
import { UploadImageToS3 } from "../components/s3/s3-details";
import UploadImage from "../components/s3/upload-image";
import { useNavigate } from "react-router-dom";

const CustomAds = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    companyURL: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [isFormSubmit, setIsFormSubmit] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileInput = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        setSelectedFile(file);
        // if (img.width === 40 && img.height === 180) {
        //   setSelectedFile(file);
        // } else {
        //   alert("Image must be 40*180 dimensions.");
        //   setSelectedFile(null);
        // }
      };
      img.src = event.target.result;
      setSelectedFile(file);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    setIsFormSubmit(true);
    e.preventDefault();

    if (!selectedFile) {
      alert("Please select a valid file to upload.");
      setIsFormSubmit(false);
      return;
    }

    try {
      const uploadedImageURL = await UploadImageToS3.uploadImage(selectedFile);

      const collectionName = databaseKey();
      if (collectionName) {
        const contactsRef = fetchData(`${collectionName}/banner`);
        const newRef = await pushData(contactsRef, {
          ...formData,
          paymentStatus: "pending",
          imageUrl: uploadedImageURL,
          approved: "false",
          timestamp: new Date().toISOString(),
        });
        localStorage.setItem("paymentId", newRef.key);
        setSelectedFile(null);
        setFormData({
          name: "",
          email: "",
          companyURL: "",
        });
      }
      setIsFormSubmit(false);
      navigate("/payment");
    } catch (error) {
      console.error("Error adding document: ", error);
      setIsFormSubmit(false);
    }
  };

  return (
    <>
      <main id="main" className="main-container">
        <div className="breadcrumbs" data-aos="fade-in">
          <div className="container">
            <h2>Ads</h2>
            <p>
              Submit your company's advertisement details below, and let us help
              you reach your audience effectively.
            </p>
          </div>
        </div>
        <div className="feedback-form-container">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <div className="feedback-inputs">
                  <label htmlFor="name" className="feedback-label">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="feedback-inputs">
                  <label htmlFor="email" className="feedback-label">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="feedback-inputs">
              <label htmlFor="companyURL" className="feedback-label">
                Company URL
              </label>
              <input
                type="text"
                name="companyURL"
                id="companyURL"
                value={formData.companyURL}
                onChange={handleChange}
                required
              />
            </div>
            <UploadImage onFileSelect={handleFileInput} />
            <button type="submit" className="btn btn-success">
              {isFormSubmit ? "Processing..." : "Submit"}
            </button>
          </form>
        </div>
      </main>
    </>
  );
};

export default CustomAds;
